import { render, staticRenderFns } from "./page9.vue?vue&type=template&id=bfa121ce&scoped=true&"
import script from "./page9.vue?vue&type=script&lang=js&"
export * from "./page9.vue?vue&type=script&lang=js&"
import style0 from "./page9.vue?vue&type=style&index=0&id=bfa121ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa121ce",
  null
  
)

export default component.exports